import { Component, Inject } from '@angular/core';
//import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
//import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-buy-now-pay-later-dialog',
  templateUrl: './buy-now-pay-later-dialog.html',
  styleUrls: ['./buy-now-pay-later-dialog.scss'],
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatRadioModule, CommonModule],
})
export class BuyNowPayLaterDialog {
  selectedBNPL: 'Klump' | 'Stanbic_BNPL' | null = null;

  constructor(
    public dialogRef: MatDialogRef<BuyNowPayLaterDialog>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      cartDetails: any;
      pay: (data: any) => void; // Function for Klump
      stanbicPay: (data: any) => void; // Function for Stanbic BNPL
    }
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }

  proceed() {
    if (this.selectedBNPL) {
      console.log(`Selected BNPL Method: ${this.selectedBNPL}`);

      // Call the correct function based on the BNPL selection
      if (this.selectedBNPL === 'Klump') {
        this.data.pay(this.data.cartDetails);
      } else if (this.selectedBNPL === 'Stanbic_BNPL') {
        this.data.stanbicPay(this.data.cartDetails);
      }

      this.dialogRef.close(this.selectedBNPL);
    }
  }
}
